"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCodeText = exports.HidePasswordIcon = exports.ShowPasswordIcon = exports.RightArrowIcon = exports.CarIcon = exports.SubmitButton = exports.HintText = exports.InputAndLabel = exports.RightIcon = exports.LeftIcon = exports.ErrorMessage = exports.InputLabel = exports.InputElement = exports.CheckBoxElement = exports.ToggleElement = exports.InputContainer = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const car_1 = __importDefault(require("./icons/car"));
const right_arrow_1 = __importDefault(require("./icons/right-arrow"));
const show_password_1 = __importDefault(require("./icons/show-password"));
const hide_password_1 = __importDefault(require("./icons/hide-password"));
const InputContainer = building_blocks_ui_common_1.styled.div `
  width: 100%;
  position: relative;
`;
exports.InputContainer = InputContainer;
const InputAndLabel = building_blocks_ui_common_1.styled.div `
  position: relative;
  width: 100%;
`;
exports.InputAndLabel = InputAndLabel;
const InputLabel = building_blocks_ui_common_1.styled.label `
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.C1};
  position: absolute;
  left: ${(props) => props.theme.spacing[3]};
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.colors.neutral.n400};
  background-color: ${(props) => props.colors.primary.n0};
  transition: all 0.15s ease-out 0s;
  pointer-events: none;
  &.shiftRight {
    left: ${(props) => props.theme.spacing[9]};
  }
  padding: 0 ${(props) => props.theme.spacing[1]};
`;
exports.InputLabel = InputLabel;
const InputElement = building_blocks_ui_common_1.styled.input `
  border-radius: ${(props) => props.theme.border.radius.large};
  padding: ${(props) => props.theme.spacing[3] + ' ' + props.theme.spacing[4]};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  width: 100%;
  border: ${(props) => props.theme.border.width.thin} solid
    ${(props) => props.colors.neutral.n300};
  box-sizing: border-box;
  position: relative;
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  &:focus {
    outline: none;
    border-color: ${(props) => props.colors.neutral.n400};
  }
  &:focus + label,
  &.hasValue + label {
    transform: translateY(-31px);
    font-size: ${(props) => props.theme.typography.fonts.size.P2};
  }
  &:focus.hasLeftIcon + label,
  &.hasValue.hasLeftIcon + label {
    transform: translateY(-31px) translateX(-34px);
  }
  &.hasLeftIcon {
    padding-left: ${(props) => props.theme.spacing[10]};
  }
  &.hasRightIcon {
    padding-right: ${(props) => props.theme.spacing[10]};
  }
  &:disabled {
    background: ${(props) => props.colors.neutral.n50};
    border: ${(props) => props.theme.border.width.none};
    color: #7a7690;
  }
  &:disabled + label {
    background-color: white;
  }
  &.hasError {
    border: ${(props) => props.theme.border.width.thin} solid
      ${(props) => props.colors.secondary.cg_red};
  }
  ::placeholder {
    color: ${(props) => props.colors.neutral.n400};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
exports.InputElement = InputElement;
const InfoText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.C1};
  line-height: ${(props) => props.theme.typography.lineHeights.C1};
  margin-top: ${(props) => props.theme.spacing[1]};
`;
const ErrorMessage = (0, building_blocks_ui_common_1.styled)(InfoText) `
  color: ${(props) => props.colors.secondary.cg_red};
`;
exports.ErrorMessage = ErrorMessage;
const HintText = (0, building_blocks_ui_common_1.styled)(InfoText) `
  color: ${(props) => props.colors.neutral.n400};
`;
exports.HintText = HintText;
const Icon = building_blocks_ui_common_1.styled.div `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
const LeftIcon = (0, building_blocks_ui_common_1.styled)(Icon) `
  left: ${(props) => props.theme.spacing[4]};
  color: ${(props) => props.colors.primary.n600};
`;
exports.LeftIcon = LeftIcon;
const RightIcon = (0, building_blocks_ui_common_1.styled)(Icon) `
  right: ${(props) => props.theme.spacing[4]};
  color: ${(props) => props.colors.neutral.n400};

  &.isAdrilla {
    right: ${(props) => props.theme.spacing[2]};
  }
`;
exports.RightIcon = RightIcon;
//TODO: remove this when button component is available
const SubmitButton = building_blocks_ui_common_1.styled.button `
  background-color: ${(props) => props.colors.primary.g300};
  cursor: pointer;
  height: 44px;
  width: 44px;
  border-radius: ${(props) => props.theme.border.radius.large};
  color: ${(props) => props.colors.primary.n0};
  border: ${(props) => props.theme.border.width.none};
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.SubmitButton = SubmitButton;
const CarIcon = (0, building_blocks_ui_common_1.styled)(car_1.default) `
  width: 32px;
  height: 32px;
  margin-top: 3px;
`;
exports.CarIcon = CarIcon;
const RightArrowIcon = (0, building_blocks_ui_common_1.styled)(right_arrow_1.default) ``;
exports.RightArrowIcon = RightArrowIcon;
const HidePasswordIcon = (0, building_blocks_ui_common_1.styled)(hide_password_1.default) `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.HidePasswordIcon = HidePasswordIcon;
const ShowPasswordIcon = (0, building_blocks_ui_common_1.styled)(show_password_1.default) `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.ShowPasswordIcon = ShowPasswordIcon;
const CheckBoxElement = building_blocks_ui_common_1.styled.input `
  position: relative;
  display: block;
  width: ${(props) => props.dimension === 'small'
    ? props.theme.spacing[4]
    : props.theme.spacing[5]};
  height: ${(props) => props.dimension === 'small'
    ? props.theme.spacing[4]
    : props.theme.spacing[5]};
  border: ${(props) => props.theme.border.width.thin} solid
    ${(props) => props.colors.secondary.n300};
  border-radius: ${(props) => props.theme.border.radius.medium};
  box-sizing: border-box;
  &:disabled {
    background: ${(props) => props.colors.secondary.n50};
    border: ${(props) => props.theme.border.width.none};
    color: ${(props) => props.colors.secondary.n50};
  }
  &:disabled + label {
    background-color: white;
  }
  &.hasError {
    border: ${(props) => props.theme.border.width.thin} solid
      ${(props) => props.colors.secondary.cg_red};
  }
  :checked {
    accent-color: ${(props) => props.colors.primary.g300};
  }
`;
exports.CheckBoxElement = CheckBoxElement;
const ToggleElement = building_blocks_ui_common_1.styled.label `
  /* toggle in label designing */
  .toggle {
    position: relative;
    display: inline-block;
    width: ${(props) => props.theme.spacing[8]};
    height: ${(props) => props.theme.spacing[6]};
    border-radius: 30px;
    border: ${(props) => props.theme.border.radius.small} solid
      ${(props) => props.colors.secondary.n300};
    background: ${(props) => props.colors.secondary.n300};
  }

  /* After slide changes */
  .toggle:after {
    background: ${(props) => props.colors.primary.n0};
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
    transform: rotate(-180deg);
    content: '';
    position: absolute;
    width: ${(props) => props.theme.spacing[5]};
    height: ${(props) => props.theme.spacing[5]};
    border-radius: 50%;
    top: 2px;
    left: 1px;
    transition: all 0.5s;
  }

  /* Checkbox checked effect */
  .checkbox:checked + .toggle::after {
    left: 18px;
  }

  /* Checkbox checked toggle label bg color */
  .checkbox:checked + .toggle {
    border: ${(props) => props.theme.border.radius.small} solid
      ${(props) => props.colors.primary.g300};
    background-color: ${(props) => props.colors.primary.g300};
  }

  /* Checkbox vanished */
  .checkbox {
    display: none;
  }
`;
exports.ToggleElement = ToggleElement;
const CountryCodeText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.P1};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  color: ${(props) => props.colors.primary.n600};
`;
exports.CountryCodeText = CountryCodeText;
//# sourceMappingURL=input.styles.js.map